import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemDespesaPrevista from "model/viagem/ViagemDespesaPrevista";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ViagemDespesaPrevistaService implements BaseServiceCadastros<ViagemDespesaPrevista> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/viagemDespesaPrevista/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    salvar(data: FormData) {
        return new Promise<ViagemDespesaPrevista>((resolve, reject): void => {
            apiFile
                .post(`/viagemDespesaPrevista`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ViagemDespesaPrevista>((resolve, reject): void => {
            api
                .get(`/viagemDespesaPrevista/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(viagemDespesa: ViagemDespesaPrevista) {
        return new Promise<ViagemDespesaPrevista>((resolve, reject): void => {
            api
                .post(`/viagemDespesaPrevista/incluir`, JSON.stringify(viagemDespesa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(viagemDespesa: ViagemDespesaPrevista) {
        return new Promise<ViagemDespesaPrevista>((resolve, reject): void => {
            api
                .put(`/viagemDespesaPrevista/editar`, JSON.stringify(viagemDespesa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/viagemDespesaPrevista/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getUsuariosDisponiveis() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/viagemDespesaPrevista/usuariosDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getCentroCustoDisponiveis() {
        return new Promise<CentroCusto[]>((resolve, reject): void => {
            api
                .get(`/viagemDespesaPrevista/centroscusto`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposDespesa() {
        return new Promise<ViagemTipoDespesa[]>((resolve, reject): void => {
            api
                .get(`/viagemDespesaPrevista/tiposDespesa`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    podeAlterar(situacao: string) {
        return ["ABERTA", "ENVIADA_APROVACAO", "REJEITADA"].includes(situacao);
    }

     getFormaPagamento(formaPagamento: "DINHEIRO" | "CREDITO" | "PAGAMENTO_ANTECIPADO" | null): string {
        if(formaPagamento === "DINHEIRO") {
            return "Dinheiro";
        }
        if(formaPagamento === "CREDITO") {
            return "Crédito";
        }
        if(formaPagamento === "PAGAMENTO_ANTECIPADO") {
            return "Pagamento Antecipado";
        }
        return "Não informada";
    }

}

export default ViagemDespesaPrevistaService;